import { LitElement, html, css } from 'lit'

class HHButtonWrapper extends LitElement {
  static properties = {
    // Thess properties are used on the add to cart button to display the total price
    singlePrice: {
      type: Number,
      attribute: 'data-single-price',
    },
    quantityInputElement: {
      type: Object,
      state: true,
    },
    atcPriceElement: {
      type: Object,
      state: true,
    }
  }

  constructor() {
    super()
    this.singlePrice = 0
    this.quantityInputElement = null
    this.atcPriceElement = null
  }

  firstUpdated() {
    if (this.singlePrice) {
      requestAnimationFrame(() => {
        this.queryQuantityElement()
        this.queryAtcPriceElement()
        this.updateDisplayPrice(false)

        window.addEventListener('changeQuantity', (event) => {
          this.updateDisplayPrice(event)
        })
      })
    }
  }

  queryQuantityElement() {
    const actContainer = this.closest('.js-atc')
    if (!actContainer) return
    this.quantityInputElement = actContainer.querySelector('hh-quantity-input')?.shadowRoot?.querySelector('.input')
  }

  queryAtcPriceElement() {
    this.atcPriceElement =  this.querySelector('.js-atc-price')
  }

  updateDisplayPrice(event) {
    const quantity = event?.detail?.value || this.quantityInputElement?.value
    const totalPrice = (quantity * this.singlePrice / 100).toFixed(2)
    this.atcPriceElement.textContent = window.variantStrings.addToCartWithPriceExtend.replace('{{ price }}', `$${totalPrice}`)
  }

  render() {
    return html`<slot></slot>`
  }

  static styles = css`
    ::slotted(button) {
      cursor: pointer;
      box-sizing: border-box !important;
      color: var(--hh-color, #FDFCF8);
      background-color: var(--hh-background, #000);
      border: var(--hh-border-width, 1px) solid var(--hh-border-color, #000);
      transition: all var(--hh-duration-default, 300ms);
      font: var(--hh-font);
      letter-spacing: var(--hh-letter-spacing);
      text-transform: var(--hh-text-transform);
      padding: 0 2rem;
      min-height: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    ::slotted(button:hover:not(:disabled)) {
      color: var(--hh-color-hover, #000);
      background-color: var(--hh-background-hover, #FDFCF8);
      border-color: var(--hh-border-color-hover, #000);
    }

    ::slotted(button:disabled) {
      cursor: default;
      color: var(--hh-color-disabled);
      background-color: var(--hh-background-disabled);
      border-color: var(--hh-background-disabled);
    }

    ::slotted(button:focus-visible) {
      outline: var(--hh-width-focus, 0.2rem) solid var(--hh-color-focus) !important;
      outline-offset: -0.1rem !important;
    }

    :host([width='full']) ::slotted(button) {
      width: 100%;
      max-width: none;
      box-sizing: border-box !important;
    }

    :host([theme='tertiary']) ::slotted(button),
    :host([theme='quaternary']) ::slotted(button) {
      position: relative;
      background: var(--hh-background, transparent);
      padding: var(--hh-padding, 0);
      border: none;
    }

    :host([theme='tertiary']) ::slotted(button):after,
    :host([theme='quaternary']) ::slotted(button):after {
      content: '';
      position: absolute;
      left: 0;
      bottom: var(--hh-border-bottom-offset, 0);
      background-color: currentColor;
      width: calc(100% - var(--hh-letter-spacing, 0px));
      height: var(--hh-underline-width, 1px);
    }

    :host([theme='tertiary']) ::slotted(button:hover:not(:disabled)):after {
      height: var(--hh-underline-width-hover, 2px);
      background-color: var(--hh-underline-color-hover, currentColor);
    }

    :host([theme='tertiary']) ::slotted(button:focus-visible):after,
    :host([theme='quaternary']) ::slotted(button:focus-visible):after {
      transition: none;
      height: var(--hh-underline-width-hover, 2px);
      background-color: var(--hh-underline-color-focus, currentColor);
    }

    :host([theme='quaternary']) ::slotted(button:not(:focus-visible)):after {
      display: none;
    }

    :slotted() {
      font: var(--hh-font);
    }

    :host([decoration~='rounded']) ::slotted(button) {
      border-radius: var(--hh-border-radius, 4px);
    }
  `
}

customElements.define('hh-button-wrapper', HHButtonWrapper)
